"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    EN: ['all week'],
    AR: ['كل الاسبوع'],
};
